import styled from 'styled-components';
import { breakpoint, SvgComponent } from '@grays-npm/component-library';

export type NotificationCardProps = {
  titleText: string;
  text: string;
  buttonContents?: JSX.Element | string;
  SvgIcon: SvgComponent;
  dismissContent: JSX.Element | string;
  color: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacings[3].rem};
  background-color: ${({ theme }) => theme.colors.neutrals.solidGrays[8]};
  padding: ${({ theme: { spacings } }) =>
    `${spacings[3].rem} ${spacings[6].rem} ${spacings[3].rem} ${spacings[4].rem}`};
  border-left: 2px solid ${({ color }) => color};
  border-radius: ${({ theme: { borderRadius } }) =>
    `0 ${borderRadius.default} ${borderRadius.default} 0`};
  fill: ${({ color }) => color};
  cursor: pointer;

  ${breakpoint('lg')`
    flex-direction: row;
    padding-right: ${({ theme }) => theme.spacings[4].rem};
  `}

  :hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }

  transition: box-shadow 250ms ease-in;
`;

const Content = styled.div`
  :last-child {
    margin-top: ${({ theme }) => theme.spacings[2].rem};
  }
`;

const IconDesktop = styled.div`
  display: none;

  ${breakpoint('lg')`
    display: flex;
    margin-right: ${({ theme }) => theme.spacings[4].rem};
  `}
`;

const IconMobile = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.spacings[3].rem};
  ${breakpoint('lg')`
    display: none;
  `};
`;

const Title = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacings[2].rem};

  ${breakpoint('lg')`
    margin-left: 0;
  `}
`;

const RightContent = styled.div`
  margin-top: ${({ theme }) => theme.spacings[2].rem};
  ${breakpoint('lg')`
    margin-top: 0;
    margin-left: auto;
    display: flex;
    align-items: center;

    > * {
      margin-left: ${({ theme }) => theme.spacings[4].rem};
    }`}
`;

const NotificationCard: React.FC<NotificationCardProps> = ({
  titleText,
  text,
  buttonContents,
  SvgIcon,
  dismissContent,
  color,
  onClick,
}) => (
  <Container onClick={onClick} color={color}>
    <IconDesktop>
      <SvgIcon width={24} />
    </IconDesktop>
    <Content>
      <Title>
        <IconMobile>
          <SvgIcon width={24} />
        </IconMobile>
        <strong>{titleText}</strong>
      </Title>
      {text}
    </Content>
    <RightContent>
      {buttonContents && buttonContents}
      {dismissContent && dismissContent}
    </RightContent>
  </Container>
);

export default NotificationCard;
